import { useQuery, useQueryClient } from "@tanstack/react-query";
import { binService } from "../services/binService";
import { bankService } from "../services/bankService";
import { saleService } from "../services/saleService";
import { materialService } from "../services/materialService";
import { notificationService } from "../services/notificationService";
import { queryKeys } from "./keys";
import { binFromPayload } from "./bin";

export function useBin(enabled = true) {
  return useQuery({
    queryKey: queryKeys.bin,
    queryFn: async () => binFromPayload(await binService.getUserBin()),
    enabled,
  });
}

export function useBanks(enabled = true) {
  return useQuery({
    queryKey: queryKeys.banks,
    queryFn: () => bankService.getUserBanks(),
    enabled,
  });
}

export function useSales(enabled = true) {
  return useQuery({
    queryKey: queryKeys.sales,
    queryFn: () => saleService.getUserSales(),
    enabled,
  });
}

export function useMaterials() {
  return useQuery({
    queryKey: queryKeys.materials,
    queryFn: async () => {
      const data = await materialService.getAllMaterials();
      return Array.isArray(data) ? data : [];
    },
    staleTime: 60 * 1000,
  });
}

export function useNotificationList(filter) {
  return useQuery({
    queryKey: queryKeys.notifications(filter),
    queryFn: async () => {
      const response = await notificationService.getList({
        unreadOnly: filter === "unread",
      });
      return {
        notifications: response.data?.data?.notifications || [],
        unreadCount: Number(response.data?.data?.unreadCount) || 0,
      };
    },
  });
}

export function useNotificationCount(enabled = true) {
  return useQuery({
    queryKey: queryKeys.notificationCount,
    queryFn: async () => {
      const response = await notificationService.getList({ limit: 1 });
      return Number(response.data?.data?.unreadCount) || 0;
    },
    enabled,
    refetchInterval: 30000,
  });
}

export function useRefreshCounts() {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.bin });
    queryClient.invalidateQueries({ queryKey: queryKeys.notificationCount });
    queryClient.invalidateQueries({ queryKey: ["notifications"] });
  };
}
